import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { OrganizationSyncPage } from '@features/admin/organization-sync';

const searchSchema = z.object({
  // Bez filtru se ukazuje to, kvuli cemu se sem chodi — nove organizace.
  state: z.enum(['ALL', 'NEW', 'CHANGED', 'ROLE_MISMATCH', 'DUPLICATE', 'MISSING_ID', 'ONLY_IN_PORTAL']).optional().default('NEW'),
  // Dodavatele (qNNP_Dodavatele) / klienti (qNNP_Organizace).
  kind: z.enum(['ALL', 'SUPPLIER', 'CLIENT']).optional().default('ALL'),
});

export type AdminOrganizationSyncSearch = z.infer<typeof searchSchema>;

export const Route = createFileRoute('/admin/organization-sync/')({
  validateSearch: search => searchSchema.parse(search),
  component: RouteComponent,
});

function RouteComponent() {
  return <OrganizationSyncPage />;
}
